//NEW STYPEPARAMS METHOD
var LAYOUT_DIRECTION = {
    LEFT_TO_RIGHT: 'LEFT_TO_RIGHT',
    RIGHT_TO_LEFT: 'RIGHT_TO_LEFT',
};
export default LAYOUT_DIRECTION;
//# sourceMappingURL=behaviourParams_gallery_layoutDirection.js.map